import React, { } from "react";
import BrandComponents from "../../Masters/Brand/BrandComponents";

function ProductionOrderTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "PO Number", field: "productionordernumber" },
    { label: "Job Number", field: "jobnumber" },
    { label: "Part Number", field: "partno" },
    { label: "Size", field: "size" },
    { label: "Customer Name", field: "customername" },
    { label: "Date", field: "podate" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"PRODUCTION ORDER LIST"}
        apiField={"productionorder"}
        addButton={"+ ADD"}
        createRoute={"/PorderCreate"}
        viewRoute={"/PorderView"}
      />
    </div>
  );
}

export default ProductionOrderTable;
